"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMortgageOutputs = void 0;
var getInsuranceRate_1 = require("./getInsuranceRate");
var MortgageHandler_1 = require("./MortgageHandler");
var getRateTable = function (yrStart, yrLength, yrStep, raStart, raLength, raStep, loanAmount) {
    var result = [];
    var rateStart = raStart;
    do {
        var rateTable = { rate: rateStart, byYears: [] };
        var yearStart = yrStart;
        do {
            var monthlyInterestRate = (rateStart / 12 / 100);
            var monthlyPayment = MortgageHandler_1.amortize(loanAmount, monthlyInterestRate, yearStart * 12);
            var byYears = [{ year: yearStart, payment: Math.ceil(monthlyPayment) }];
            rateTable = __assign(__assign({}, rateTable), { byYears: __spreadArrays(rateTable.byYears, byYears) });
            yearStart = yearStart += yrStep;
        } while (yearStart <= yrLength);
        result = __spreadArrays(result, [rateTable]);
        rateStart = rateStart + raStep;
    } while (rateStart <= raLength);
    return result;
};
exports.getMortgageOutputs = function (mortgageInputs) {
    var planList = mortgageInputs.hasOutstandingMortgage ? mortgageInputs.mortgagePlanListWithProperty : mortgageInputs.mortgagePlanList;
    var insuranceResult = getInsuranceRate_1.compareInsuranceRate(mortgageInputs.propertyValue, mortgageInputs.downPayment, mortgageInputs.tenor, planList, mortgageInputs.mortgageLimitTable, mortgageInputs.adValoremStampDuty);
    var insurance = insuranceResult.amount;
    var error = insuranceResult.error;
    var insuranceInitial = mortgageInputs.isInsuranceMonthlyRepay ? 0 : insurance;
    var legalAmount = mortgageInputs.legalAmount;
    var loanAmount = Math.ceil(mortgageInputs.propertyValue - mortgageInputs.downPayment + (mortgageInputs.isInsuranceMonthlyRepay ? insuranceResult.amount : 0));
    var monthlyInterestRate = (mortgageInputs.interestRate / 12 / 100);
    var monthlyPayment = MortgageHandler_1.amortize(loanAmount, monthlyInterestRate, mortgageInputs.tenor * 12);
    var balance = loanAmount;
    var monthIndex = 1;
    var schedule = [];
    while (balance > 0) {
        var interestCurrentMonth = balance * monthlyInterestRate;
        var base = (monthlyPayment - interestCurrentMonth);
        var newBalance = balance >= base ? balance - base : 0;
        var obj = {
            monthIndex: monthIndex,
            principle: Math.ceil(monthlyPayment - interestCurrentMonth),
            interest: Math.ceil(interestCurrentMonth),
            balance: Math.ceil(newBalance),
            payment: Math.ceil(monthlyPayment)
        };
        schedule.push(obj);
        if (obj.balance === 0)
            break;
        balance = newBalance;
        monthIndex = monthIndex + 1;
    }
    var buyerStampDutyTax = mortgageInputs.buyerStampDuty
        ? (mortgageInputs.propertyValue * mortgageInputs.buyerStampDutyRate) / 100
        : 0;
    var adValoremStampDutyTax = mortgageInputs.adValoremStampDuty
        ? (mortgageInputs.propertyValue * mortgageInputs.adValoremStampDutyRate) / 100
        : MortgageHandler_1.getDiscountedAdValoremStampDutyRate(mortgageInputs.propertyValue, mortgageInputs.doubleAdValoremStampDutyRateTable);
    var specialStampDutyTax = mortgageInputs.lastTransactionInMonth === -1
        ? 0
        : MortgageHandler_1.getSpecialStampDutyTax(mortgageInputs.propertyValue, mortgageInputs.lastTransactionInMonth, mortgageInputs.specialStampDutyRateTable);
    var totalTax = buyerStampDutyTax + adValoremStampDutyTax + specialStampDutyTax;
    var totalInterest = schedule.map(function (it) { return it.interest; }).reduce(function (a, b) { return a + b; }, 0);
    var commission = (mortgageInputs.propertyValue * mortgageInputs.commissionRate) / 100;
    var totalCashOutlay = totalTax + commission + mortgageInputs.downPayment + insuranceInitial + legalAmount;
    var totalExpenses = totalCashOutlay + loanAmount + totalInterest;
    var rateTable = getRateTable(mortgageInputs.rateTableInputs.yearStart, mortgageInputs.rateTableInputs.yearLength, mortgageInputs.rateTableInputs.yearStep, mortgageInputs.rateTableInputs.rateStart, mortgageInputs.rateTableInputs.rateLength, mortgageInputs.rateTableInputs.rateStep, loanAmount);
    return {
        monthlyPayment: monthlyPayment,
        schedule: schedule,
        rateTable: rateTable,
        totalTax: totalTax,
        totalInterest: totalInterest,
        commission: commission,
        totalCashOutlay: totalCashOutlay,
        totalExpenses: totalExpenses,
        insurance: insurance,
        insuranceInitial: insuranceInitial,
        loanAmount: loanAmount,
        legalAmount: legalAmount,
        error: error
    };
};
